import React from 'react';
import { motion } from 'framer-motion';
import { Download, ExternalLink, ArrowRight } from 'lucide-react';
import { Footer } from '../../components/Footer';
import { Button } from '../../components/ui/Button';
export function CampDesigns() {
  const pdfUrl = 'https://wearhaus.net/wp-content/uploads//2017/03/2017campdesigns.pdf';
  const imageUrl = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesign%2F2017CampDesigns.jpg&site=11804&w=600&h=770&user=6074&opt=w3';
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-1010">
      <main className="flex-grow" data-id="element-1011">
        {/* Hero Section */}
        <section className="bg-white py-16 md:py-24 border-b border-gray-100" data-id="element-1012">
          <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-1013">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-1014">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1015">
                Camp Designs
              </h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-1016">
                Explore our curated collection of custom camp designs. From
                classic summer camp vibes to modern aesthetics, find the perfect
                inspiration for your next project.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Catalog Showcase Section */}
        <section className="py-16 md:py-24" data-id="element-1017">
          <div className="container mx-auto px-4" data-id="element-1018">
            <div className="flex flex-col items-center" data-id="element-1019">
              {/* Catalog Image Card */}
              <motion.div className="relative group cursor-pointer" initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} whileHover={{
              y: -8
            }} data-id="element-1020">
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="block relative rounded-xl overflow-hidden shadow-2xl ring-1 ring-gray-900/5 bg-white max-w-[600px] w-full" data-id="element-1021">
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300 z-10" data-id="element-1022" />
                  <img src={imageUrl} alt="2017 Camp Designs Catalog" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" width={600} height={770} loading="eager" data-id="element-1023" />

                  {/* Overlay Hint */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 pointer-events-none" data-id="element-1024">
                    <div className="bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg flex items-center gap-2 text-gray-900 font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-1025">
                      <ExternalLink className="w-5 h-5" data-id="element-1026" />
                      <span data-id="element-1027">Open Catalog</span>
                    </div>
                  </div>
                </a>
              </motion.div>

              {/* CTA Section */}
              <motion.div className="mt-12 text-center" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} data-id="element-1028">
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-1029">
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer" data-id="element-1030">
                    <Button variant="primary" className="px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all flex items-center gap-3" data-id="element-1031">
                      <Download className="w-5 h-5" data-id="element-1032" />
                      View Full Catalog (PDF)
                    </Button>
                  </a>
                </div>
                <p className="mt-4 text-sm text-gray-500" data-id="element-1033">
                  PDF format • Opens in a new tab
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Additional Info / Trust Section */}
        <section className="bg-white py-16 border-t border-gray-100" data-id="element-1034">
          <div className="container mx-auto px-4 text-center" data-id="element-1035">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1036">
              Ready to start your order?
            </h2>
            <div className="flex justify-center gap-4" data-id="element-1037">
              <a href="/contact" data-id="element-1038">
                <Button variant="outline" className="flex items-center gap-2" data-id="element-1039">
                  Contact Us <ArrowRight className="w-4 h-4" data-id="element-1040" />
                </Button>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1041" />
    </div>;
}